import { Routes } from "@angular/router";
import { LoginComponent } from "./components/auth/login/login.component";
import { RegisterComponent } from "./components/auth/register/register.component";
import { ItemsComponent } from "./components/items/items.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { AddItemComponent } from "./components/add-item/add-item.component";
import { CatalogueComponent } from "./components/catalogue/catalogue.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { AllRequestsComponent } from "./components/all-requests/all-requests.component";
import { RequestByItemsComponent } from "./components/request-by-items/request-by-items.component";
import { RequestByCustomersComponent } from "./components/request-by-customers/request-by-customers.component";
import { RequestListComponent } from "./components/request-list/request-list.component";
// import { async } from '@angular/core/testing';

export const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "register", component: RegisterComponent },
  { path: "login", redirectTo: "", pathMatch: "full" },
  { path: "add-item", component: AddItemComponent },
  // { path: 'settings', component: SettingsComponent },
  {
    path: "items",
    loadChildren: () =>
      import("./modules/items/items.module").then(m => m.ItemsModule)
  },

  {
    path: "dashboard",
    loadChildren: () =>
      import("./modules/dashboard/dashboard.module").then(
        m => m.DashboardModule
      )
  },

  {
    path: "catalogue",
    loadChildren: () =>
      import("./modules/catalogue/catalogue.module").then(
        m => m.CatalogueModule
      )
  },
  {
    path: "requests",
    loadChildren: () =>
      import("./modules/request/request.module").then(m => m.RequestModule)
  },
  { path: "**", component: PageNotFoundComponent }
];

export const ItemRoutes: Routes = [{ path: "", component: ItemsComponent }];

export const dashboardRoutes: Routes = [
  { path: "", component: DashboardComponent }
];

export const catalogueRoutes: Routes = [
  { path: "", component: CatalogueComponent }
];

export const requestsRoutes: Routes = [
  {
    path: "",
    component: AllRequestsComponent,
    children: [
      { path: "", component: RequestListComponent },
      { path: "items", component: RequestByItemsComponent },
      { path: "customers", component: RequestByCustomersComponent },
      { path: "all", component: RequestListComponent }
    ]
  }
];
